import { render } from "./processFee.vue?vue&type=template&id=50f108c3&scoped=true"
import script from "./processFee.vue?vue&type=script&lang=js"
export * from "./processFee.vue?vue&type=script&lang=js"

import "./processFee.vue?vue&type=style&index=0&id=50f108c3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50f108c3"

export default script